export default {
  TITLE: 'Your workspaces',
  BUTTON_ADMIN_TEXT: 'Admin',
  BUTTON_INBOX_TEXT: 'Inbox',
  BUTTON_ADD_TEXT: 'Add new workspace',
  FILED_ADD_PLACEHOLDER: 'Enter workspace name'
};
